import { render, staticRenderFns } from "./ContainerTareWeightPop.vue?vue&type=template&id=67b88ba6"
import script from "./ContainerTareWeightPop.vue?vue&type=script&lang=js"
export * from "./ContainerTareWeightPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b88ba6')) {
      api.createRecord('67b88ba6', component.options)
    } else {
      api.reload('67b88ba6', component.options)
    }
    module.hot.accept("./ContainerTareWeightPop.vue?vue&type=template&id=67b88ba6", function () {
      api.rerender('67b88ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ContainerTareWeightPop.vue"
export default component.exports